import { render } from "./LevelBadge.vue?vue&type=template&id=390030d0&scoped=true&ts=true"
import script from "./LevelBadge.vue?vue&type=script&lang=ts"
export * from "./LevelBadge.vue?vue&type=script&lang=ts"

import "./LevelBadge.vue?vue&type=style&index=0&id=390030d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390030d0"]])

export default __exports__